module.exports = __webpack_public_path__ + "static/media/icon-configuracao.f6238b3b.svg";